import React, { Component } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import ReactTable from 'react-table';
import { _delete, get } from '../../../server/actions';
import Modal from 'react-modal';
import ESEAForm from './ESEAForm';
import CustomSubmit from '../../Misc/customSubmit';
import { _addNotification, getDistrictLoginModuleAccess } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
class ESEAFormList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            deleteModalIsOpen: false,
            deleteRec: undefined,
            data: [],
            searchData: [],
            search: '',
        }

    }
    componentWillMount() {
        this.props.changeShowHideSchoolFitler(false);
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getESEAFormList();
    }
    onSearchData = () => {
        const { search, data } = this.state;
        if (search.length > 0) {
            const res = data.filter(rec => {
                if ((rec.id).toString().startsWith(search)) {
                    return rec;
                } else if ((rec.parentEmail).toString().startsWith(search)) {
                    return rec;
                } else if ((rec.date).toString().startsWith(search)) {
                    return rec;
                }
            });
            this.setState({ searchData: res });
        } else {
            return this.setState({ searchData: data });;
        }
    }
    getESEAFormList = () => {
        let userInfo = getLoginDistrictInfo();
        let districtId = userInfo.districtId;
        let url = `/eseaForms?districtId=${districtId}&schoolYear=${userInfo.schools[0].activeSchoolYear}&access_token=`;

        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const { resp } = data;
            this.setState({
                data: resp,
                searchData: resp
            })
        }).catch(
            (error) => {
                console.log('Get deleted students data response', error)
            }
        );
    }
    onDeleteRec = (e, callback) => {
        const { id } = this.state.deleteRec;
        const url = `/eseaForms/${id}?access_token=`;
        _delete(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            console.log(data);
            callback(true);
            this.setState({ deleteRec: undefined, deleteModalIsOpen: false });
            this.getESEAFormList();
        }).catch(
            (error) => {
                console.log('Get deleted students data response', error)
            }
        );
    }
    getColumns = () => {
        return [
            {
                Header: 'Id',
                accessor: 'id',
                width: 100,
            },
            {
                Header: 'Date',
                accessor: 'date',
                width: 100,
            },
            {
                accessor: 'parentEmail',
                Header: 'Parent Email',
                sortable: true,
                style: { textAlign: 'left' }
            },
            {
                accessor: 'indicator',
                Header: 'Indicator',
                width: 150,

            },
            {
                id: 'actionButton',
                accessor: "studentId",
                Header: 'ACTIONS',
                style: { textAlign: 'center' },
                width: 120,
                Cell: ({ row }) => (<div>
                    <a title="Delete" onClick={(e) => {
                        this.setState({ deleteModalIsOpen: true, deleteRec: row._original })

                    }}>
                        <i className="fa fa-trash-o tbl-rounded-icon bg-color-1 fa-icon" style={{ width: '23px', height: '23px', margin: '2px' }} />
                    </a>
                </div>)
            }
        ]
    }
    render() {
        const { loading, searchData, search } = this.state;
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={loading}
                    />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                            <h2><span>ESEA Form List</span></h2>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-3'>
                            <input name="search" autoComplete='off' value={search} className='form-control' type='text' onChange={(e) => {
                                this.setState({ search: e.target.value }, () => {
                                    this.onSearchData();
                                });
                            }} />
                        </div>
                    </div>
                    <div className='row' style={{ marginTop: '10px' }}>
                        <div className='col-md-12'>
                            <ReactTable
                                showPaginationBottom={true}
                                columns={this.getColumns()}
                                data={searchData}
                                defaultPageSize={3}
                                className="-striped -highlight"
                                {...checkboxProps}
                                SubComponent={(row) => {
                                    const { original } = row;
                                    return (<ESEAForm {...this} {...{ data: original, getESEAFormList: this.getESEAFormList }} />)
                                }}
                            />
                        </div>
                    </div>
                </div>

                <Modal
                    isOpen={this.state.deleteModalIsOpen}
                    onRequestClose={() => this.setState({ deleteModalIsOpen: false })}
                    style={deleteStyles}
                    contentLabel="Activation">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting ESEA Form</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to delete the record?</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={() => this.setState({ deleteModalIsOpen: false, deleteRec: undefined })}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                        </button>
                        <CustomSubmit id="deleteConfirm" type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} handleSubmit={(e, callback) => this.onDeleteRec(e, callback)}>
                            <i className="glyphicon glyphicon-ok"></i> Delete
                        </CustomSubmit>
                    </div>
                </Modal>

            </div>

        );
    }
}

export default ESEAFormList;


// WEBPACK FOOTER //
// ./src/components/District/EseaForm/index.js